/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {ReactComponent as OnahLogo} from 'assets/svgs/onah.svg'
import classes from './landing.module.scss';
import { isAuthenticated, reduceObject } from 'helper';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'routes/routes';
import { useOnahDispatch, useOnahSelector } from 'store/hooks';
import { KybStatus } from 'interface/merchant';
import { checkOnboardingStatus, getOnboardingNextScreen } from 'store/slices/onboarding';

type Props = {}

const Landing = (props: Props) => {
  const navigate = useNavigate();
  const {merchant} = useOnahSelector(state => state.user);
  const dispatch = useOnahDispatch()

  useEffect(() => {
    let honour = true;
    if(isAuthenticated()) {
      const isOwner = merchant?.user.member.team.ownerId === merchant?.user.id;
      const isVerified = merchant?.kybStatus === KybStatus.VERIFIED;
      const isRejected = merchant?.kybStatus === KybStatus.REJECTED;
      if(isOwner && !(isVerified || isRejected)) {
        dispatch(
          checkOnboardingStatus({
            onSuccess(summary) {
              if(honour) {
                if(Object.values(reduceObject(summary)).every(r => r)) {
                  navigate(Routes.app, {replace: true});
                } else {
                  navigate(getOnboardingNextScreen(summary), {replace: true});
                }
              }
            },
            onFailed() {
              if(honour) {
                navigate(Routes.app, {replace: true});
              }
            },
          })
        )
      } else {
        if(honour) {
          navigate(Routes.app, {replace: true});
        }
      }
    } else {
      if(honour) {
        navigate(Routes.auth, {replace: true});
      }
    }
    return () => {
      honour = false;
    }
  }, []);

  return (
    <div className={classes.landing__page}>
      <OnahLogo className="animate-pulse"/>
    </div>
  )
}

export default Landing